"use strict";

export function initInScope($scope) {
    $scope.find('.modal').on('shown.bs.modal', function (e) {
        $(this).find('input').first().focus();
    })
}